import Logger from "../../common/util/Logger.js";

export const SET_MODAL = "SET_MODAL";
export const ADD_DROPDOWN = "ADD_DROPDOWN";
export const POP_DROPDOWN = "POP_DROPDOWN";
export const CLEAR_MODAL_DROPDOWNS= "CLEAR_MODAL_DROPDOWNS";

/**
 * Sets active modal
 * @param {node} modal
 * @returns {func}
 */
export function setModal(modal){
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_MODAL,
                modal,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Sets active modal
 * @param {node} dropDown
 * @param {bool} clearEveryThingBefore
 * @returns {func}
 */
export function setDropDown(dropDown, clearEveryThingBefore = false){
    return async (dispatch, getState) => {
        try {
            if( dropDown ){
                if( clearEveryThingBefore && (getState().modal.dropDown.length>0 || getState().modal.modal!=null) ) {
                    await dispatch({
                        type: CLEAR_MODAL_DROPDOWNS,
                    });
                }
                dispatch({
                    type: ADD_DROPDOWN,
                    dropDown,
                });
            } else {
                dispatch({
                    type: POP_DROPDOWN,
                });
            }
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Clear all modals and dropDowns
 * @returns {func}
 */
export function clearModalAndDropDown(){
    return async (dispatch) => {
        try {
            dispatch({
                type: CLEAR_MODAL_DROPDOWNS,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}